export function isNonNullable<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function removeInvalidEntries<T extends object>(obj: T): Partial<T> {
  const result: Partial<T> = {};
  for (const key in obj) {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
      result[key] = obj[key];
    }
  }
  return result;
}

export function filterObjNullable<T extends object>(obj: T) {
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => isNonNullable(value))) as {
    [K in keyof T]: NonNullable<T[K]>;
  };
}
